import { useAuth } from "../../authService";

export function useRole() {
  const auth = useAuth();
  const role = auth.user?.customizations.role;

  if (role) return role;

  return undefined;
}
